import cn from 'classnames';
import type React from 'react';
import { FormProvider } from 'react-hook-form';
import { Checkout, Client, Delivery, Products } from '@features/cart';
import { Promo } from '@features/cart/promo';
import { ArrowShortLeft } from '@shared/assets';
import { useMobile } from '@shared/hooks';
import { IconButton, ListBody, PageHead, PageTitle } from '@shared/ui';
import { Blank } from 'library/components/common';
import { useCart, useCheckout } from './model';
import * as st from './styles.module.scss';

export const Cart: React.FC = () => {
  const cart = useCart();
  const checkout = useCheckout();

  const { isMobile } = useMobile();
  const isPartner = checkout.isPartner;

  return (
    <>
      <PageTitle title={'Корзина'} />
      <PageHead
        Left={
          <IconButton variant="dark" onClick={cart.close}>
            <ArrowShortLeft />
          </IconButton>
        }
      />
      <ListBody>
        {cart.items?.length === 0 && <Blank text="Корзина пуста" />}
        {cart.items?.length > 0 && (
          <>
            <section className={st.products}>
              <Products />
            </section>
            <FormProvider {...cart.methods}>
              <form onSubmit={cart.handleSubmit(checkout.payOrder)} id="orderFromCart">
                <h2 className={st.subtitle}>ПОЛУЧАТЕЛЬ</h2>
                <section className={cn(st.block, st.client)}>
                  <Client />
                </section>

                <h2 className={st.subtitle}>ДОСТАВКА</h2>
                <section className={cn(st.block, st.delivery)}>
                  <Delivery control={cart.control} />
                </section>

                {isMobile && !isPartner && (
                  <>
                    <h2 className={st.subtitle}>ПРОМОКОД</h2>
                    <section className={cn(st.block, st.promo)}>
                      <Promo />
                    </section>
                  </>
                )}

                <h2 className={st.subtitle}>ОПЛАТА</h2>
                <section className={cn(st.block, st.checkout)}>
                  {!isPartner && !isMobile && <Promo />}
                  <Checkout slot={null} checkoutData={checkout} />
                </section>
              </form>
            </FormProvider>
          </>
        )}
      </ListBody>
    </>
  );
};
